import { BaseLayout } from 'aem-libs-react-components/src/components/calculators/layouts/base-layout/BaseLayout'

import { InputFields } from '../components/InputFields'
import { ResultBoard } from '../components/ResultBoard'

export const BurinkaEarlyRepaymentContainer = () => {
  return <BaseLayout inputComponent={<InputFields />} resultComponent={<ResultBoard />} />
}
